<template>
	<div v-if="urlPdf">
		<v-btn
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 10px;"
		>
			{{ currentPage }}/{{ pageCount }}
		</v-btn>
		<v-btn
			v-if="page != 1"
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 70px;"
			@click="retrocederPagina()"
		>
			<v-icon center>mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn
			v-if="page != pageCount"
			color="accent"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 130px"
			@click="avanzarPagina()"
		>
			<v-icon center>mdi-arrow-right</v-icon>
		</v-btn>
		<v-btn
			:color="sliderValue > 99 ? 'success' : 'primary'"
			fab
			fixed
			right
			id="toolbar title"
			style="z-index: 1; margin-top: 190px"
		>
			{{ sliderValue.toFixed(0) }}
		</v-btn>
		<v-progress-linear
			:value="sliderValue"
			top
			fixed
			style="z-index: 1; margin-top:30px; position:fixed;"
		>
		</v-progress-linear>
		<div id="render-pdf">
			<pdf
				:page="page"
				:src="urlPdf"
				@num-pages="pageCount = $event"
				@page-loaded="
					currentPage = $event;
					evalSize();
				"
				style="width:100%;"
			></pdf>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import pdf from 'vue-pdf';
export default {
	components: {
		pdf,
	},
	props: {
		publicationId: {
			default: '',
		},
		seen: {
			type: Boolean,
		},
		urlPdf: {
			default: '',
		},
	},
	data() {
		return {
			change: false,
			page: 1,
			currentPage: 1,
			pageCount: 0,
			delay: false,
			read: this.seen,
			maxProgress: 0,
			sliderValue: 0,
		};
	},
	computed: {
		...mapGetters({
			person: 'Person/person',
		}),
	},
	watch: {
		publication() {
			this.page = 1;
			this.currentPage = 1;
		},
	},
	created() {
		this.scroll();
	},
	mounted() {
		//this.evalSize();
	},
	methods: {
		retrocederPagina() {
			this.page--;
			document.documentElement.scrollTop = document.documentElement.offsetHeight;
			this.sliderValue = 100;
			this.evalSize();
		},
		avanzarPagina() {
			this.page++;
			document.documentElement.scrollTop = 1;
			this.sliderValue = 0;
			this.evalSize();
		},
		readed() {
			const readed = this.page == this.pageCount;
			return readed;
		},
		scroll() {
			window.onscroll = () => {
				let max =
					Math.max(
						window.pageYOffset,
						document.documentElement.scrollTop,
						document.body.scrollTop
					) + window.innerHeight;
				this.maxProgress = document.documentElement.offsetHeight;
				let temporalValue = (max * 100) / this.maxProgress;
				if (temporalValue > this.sliderValue) {
					this.sliderValue = (max * 100) / this.maxProgress;
				}
				let bottomOfWindow = Math.ceil(max) === document.documentElement.offsetHeight;

				if (!this.delay) {
					if (bottomOfWindow && this.readed() && !this.read) {
						this.setDelay();
						this.read = true;
						this.seenPublication({
							personId: this.person._id,
							publicationId: this.publicationId,
						});
					}
				} else {
					document.documentElement.scrollTop = 50;
				}
			};
		},
		evalSize() {
			let box = document.querySelector('#render-pdf');
			let max =
				Math.max(
					window.pageYOffset,
					document.documentElement.scrollTop,
					document.body.scrollTop
				) + window.innerHeight;
			if (box.offsetHeight <= max && this.readed() && !this.read) {
				this.sliderValue = 100;
				this.read = true;
				this.seenPublication({
					personId: this.person._id,
					publicationId: this.publicationId,
				});
			} else if (box.offsetHeight <= max && this.readed() && this.read) {
				this.sliderValue = 100;
			}
		},

		setDelay() {
			this.delay = true;
			setTimeout(() => {
				this.delay = false;
			}, 300);
		},
		...mapActions({
			seenPublication: 'Person/seenPublication',
		}),
	},
};
</script>
